module.exports = __webpack_public_path__ + "Lato-Regular.7b420bc7262e42c5813a.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Regular.eot
// module id = ../../../../../src/assets/fonts/Lato-Regular.eot
// module chunks = styles